<!-- wireframe -->
<div class="wrapper" *ngIf="show">
    <div class="wrapper-body">
        <div class="container-fluid">
            <div class="row" *ngIf="apptDetails">
                <div class="col-12">
                    <div class="page-header align-items-lg-center d-flex flex-column flex-md-row">
                        <h3 class="mb-4 mb-md-0">{{apptDetails.parentDetails.studentFirstName}} {{apptDetails.parentDetails.studentLastName}} Details</h3>
                        <a routerLink="/upcoming" class="theme-button grey d-md-inline-flex d-none ml-auto mr-3">Back</a>
                        <a [routerLink]="['/admin-background-form',apptDetails.appointmentDetails.appointmentId]"
                            target="_blank" class="theme-button green">View Background Form</a>
                    </div>
                </div>

                <!-- Appoitment Detail -->
                <div class="col-12">
                    <div class="card">
                        <h5 class="mb-0 text-purple">Appointment Detail</h5>
                        <hr>
                        <div class="row">
                            <div class="col-md-4">
                                <label class="text-grey"> Date</label>
                                <p> {{apptDetails.appointmentDetails.schedules[0].appointmentDate}}</p>
                            </div>
                            <div class="col-md-4">
                                <label class="text-grey">Time</label>
                                <p> {{apptDetails.appointmentDetails.schedules[0].appointmentTime}}</p>
                            </div>
                            <div class="col-md-4">
                                <label class="text-grey">Location</label>
                                <p> {{apptDetails.appointmentDetails.location}}</p>
                            </div>
                            <div class="col-md-4">
                                <label class="text-grey">Diagnostician</label>
                                <p> {{apptDetails.appointmentDetails.diagnosticianName}}</p>
                            </div>
                            <div class="col-md-4">
                                <label class="text-grey">Assessment Type</label>
                                <p> {{apptDetails.appointmentDetails.assesmentType}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Survey Detail -->
                <div *ngIf="apptDetails.appointmentDetails.schedules[0].status!='BACKGROUNDFORMNOTSUBMIT' && apptDetails.appointmentDetails.schedules[0].status!='BACKGROUNDFORMSUBMIT'"
                    class="col-md-6">
                    <div class="card">
                        <h5 class="mb-0 text-purple">Surveys to be performed</h5>
                        <hr>
                        <div class="row">
                            <div class="col-12">
                                <div class="d-flex flex-wrap">
                                    <p class="badge badge-pill bg-purple-light mr-2  px-3 py-2"
                                        *ngFor="let survey of apptDetails.appointmentDetails.schedules[0].assesmentSurvey">
                                        {{survey.name}}</p>
                                </div>
                                <div class="d-flex flex-wrap"
                                    *ngIf="apptDetails.appointmentDetails.schedules[0].assesmentSurvey.length==0">
                                    <p class="text-warning mb-0">
                                        No Surveys Selected</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Test Detial -->
                <div *ngIf="apptDetails.appointmentDetails.schedules[0].status!='BACKGROUNDFORMNOTSUBMIT' && apptDetails.appointmentDetails.schedules[0].status!='BACKGROUNDFORMSUBMIT'"
                    class="col-md-6">
                    <div class="card">
                        <h5 class="mb-0 text-purple">Tests to be performed</h5>
                        <hr>
                        <div class="row">
                            <div class="col-12">
                                <div class="d-flex flex-wrap">
                                    <p class="badge badge-pill bg-purple-light mr-2 px-3 py-2"
                                        *ngFor="let test of apptDetails.appointmentDetails.schedules[0].assesmentTest">{{test.name}}
                                    </p>
                                </div>
                                <div class="d-flex flex-wrap"
                                    *ngIf="apptDetails.appointmentDetails.schedules[0].assesmentTest.length==0">
                                    <p class="text-warning mb-0">
                                        No Tests Selected</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Client Details -->
                <div class="col-12">
                    <div class="card">
                        <h5 class="mb-0 text-purple">Client Detail</h5>
                        <hr>
                        <div class="row">
                            <div class="col-md-4">
                                <label class="text-grey">Full Name</label>
                                <p> {{appts.studentFirstName}}
                                    {{appts.studentLastName}} </p>
                            </div>
                            <div class="col-md-4">
                                <label class="text-grey">Parent Name</label>

                                <p> {{appts.parentName}}</p>
                            </div>

                            <div class="col-md-4">
                                <label class="text-grey">Date Of Birth</label>
                                <p> {{appts.dateOfBirth}}</p>
                            </div>

                            <div class="col-md-4">
                                <label class="text-grey">Cell Number</label>
                                <p> {{appts.phoneNumber}}</p>
                            </div>
                            <div class="col-md-4">
                                <label class="text-grey">Cell Number</label>

                                <p> {{appts.cellNumber}}</p>
                            </div>
                            <div class="col-md-4">
                                <label class="text-grey">Email </label>
                                <p> {{appts.emailAddress}}</p>
                            </div>
                            <div class="col-md-4">
                                <label class="text-grey">Secondary Email</label>

                                <p> {{appts.secondaryEmailAddress}}</p>
                            </div>
                            <div class="col-md-4">
                                <label class="text-grey">Grade</label>
                                <p> {{appts.grade}}</p>
                            </div>
                            <div class="col-md-4">
                                <label class="text-grey">School Type</label>
                                <p> {{appts.schoolType}}</p>
                            </div>
                            <div class="col-md-4">
                                <label class="text-grey">School/District</label>
                                <p> {{appts.school}}</p>
                            </div>
                            <div class="col-md-4">
                                <label class="text-grey">Reason For Call</label>
                                <p> {{appts.reasonForCall}}</p>
                            </div>
                            <div class="col-md-4">
                                <label class="text-grey">Additional Comments</label>

                                <p> {{appointmentComments}}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Actions Only For Diagno. -->
                <div class="col-12 mb-5" *ngIf='userRole=="DIAGNOSTIC"'>

                    <!-- If Time Is Not Meet With Appt. || Button Will Be Disabled -->
                    <div class="actions d-flex justify-content-center" *ngIf="!startAsses">
                        <a class="theme-button" [routerLink]="['/student-observation',apptDetails.appointmentDetails.appointmentId]">Start Assessment</a>
                    </div>

                    <!-- Is Start Assesment Button Is Clicked -->
                    <div class="actions d-flex justify-content-center" *ngIf="startAsses">
                        <a (click)='finishAppt("Complete")' class="theme-button green mr-3" data-toggle="modal"
                            data-target="#modal">Complete</a>
                        <a (click)='finishAppt("Cancel")' data-toggle="modal" data-target="#modal"
                            class="theme-button danger">Cancel Appointment</a>
                    </div>
                </div>

            </div>
        </div>




    </div>
</div>


    


    <div>

        <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-scale-multiple"></ngx-spinner>
    </div>